import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import UnknownTemplate from '../../render_components/__template_components/unknown_template';

const UnknownPublicationPage = () => {
  const currentPublication = useSelector((state) => state.currentPublication.currentPublication);
  const contentData = currentPublication?.content ? JSON.parse(currentPublication.content) : null;
  const templateName = currentPublication?.template?.template_name || null;

  // Создаем path_to_folder
  const path_to_folder = currentPublication
    ? 'https://' + currentPublication.path + currentPublication.eng_name + '/'
    : null;

  const renderTemplate = () => {
    return <UnknownTemplate contentData={contentData} path_to_folder={path_to_folder} />;
  };

  return (
    <div className={styles.unknownPublicationPage}>
      <h2 className={styles.title}>Страница публикации</h2>
      <p className={styles.description}>Страница для отображения публикаций</p>
      {currentPublication && (
        <div className={styles.publicationInfo}>
          <h3>Название: {currentPublication.show_name}</h3>
          <p>ID: {currentPublication.id}</p>
        </div>
      )}
      {renderTemplate()}
    </div>
  );
};

export default UnknownPublicationPage;
